//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { QueryRenderer, ReadyState } from "react-relay";
// feed-scheduler-input-renderer imports
import { query } from "./FeedSchedulerInputRenderer.gql";
import { IRendererProps, IRendererContainer, IRendererState } from "./FeedSchedulerInput.d";
import { FeedSchedulerInput } from "./FeedSchedulerInput";
// other internals
import { CalloutBox } from "@components/callout-box";
import { IReduxState } from "@state/reducers/root.reducer";
// util
import { logger } from "@util/logger.util";
import { handleReadyStateError } from "@util/relay.util";

//////////////////
// COMPONENT
//////////////////
class FeedSchedulerInputRendererComponent extends React.PureComponent<
  IRendererProps,
  IRendererState
> {
  constructor(props: IRendererProps) {
    super(props);
    this.state = {
      boundaryError: false,
    };
  }

  public componentDidCatch(error: Error, info: React.ErrorInfo) {
    logger.error("componentDidCatch in FeedSchedulerInputRenderer", error, info);

    // Display fallback UI
    this.setState({ boundaryError: true });
  }

  public render() {
    const queryInput = this.props.queryInput || "";
    const excludeCalendars = this.props.excludeCalendars || [];
    const orgRelayId = this.props.orgId;
    const emails: string[] = [];
    const externalGroupRefetch = false;
    const teamId: string = "";
    const teamAttendeesRefetch = false;

    return (
      <QueryRenderer
        environment={this.props.environment}
        query={query}
        variables={{
          queryInput,
          orgRelayId,
          excludeCalendars,
          emails,
          externalGroupRefetch,
          teamId,
          teamAttendeesRefetch,
        }}
        cacheConfig={{}}
        render={(readyState: ReadyState) => {
          const viewer = readyState.props && readyState.props.viewer;
          const org = readyState.props && readyState.props.org;

          if (readyState.error) {
            handleReadyStateError(readyState.error, "FeedSchedulerInputRenderer");
          }

          // check for error or show a loader for first load
          if (readyState.error || this.state.boundaryError) {
            return (
              <CalloutBox error style={{ marginTop: 20 }}>
                An error has occurred. Please try refreshing the page.
              </CalloutBox>
            );
          }

          return (
            <FeedSchedulerInput
              viewer={viewer}
              org={org}
              initialPersons={this.props.initialPersons}
              selectedPersons={this.props.selectedPersons}
              onChange={this.props.onChange}
              onBlur={this.props.onBlur}
            />
          );
        }}
      />
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IRendererContainer) {
  return {};
}

export const FeedSchedulerInputRenderer = connect(
  mapStateToProps,
  {},
)(FeedSchedulerInputRendererComponent);
